import { ILayer } from '../../../types/common';

const source = 'userTracks';

const config = {
  id: source,
  type: 'line',
  source,
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-color': '#FF9C00',
    'line-width': 3,
    // 'line-pattern': 'arrow',
  },
};

const load = async ({
  courseId = null,
  huntId = null,
  event = null,
  inaccurate = false,
  trainingMode = false,
  startDate = null,
  endDate = null,
}): Promise<ILayer> => {
  const params = [
    courseId ? `course_id=${courseId}` : null,
    huntId ? `hunt_id=${huntId}` : null,
    event ? `event_select=${event}` : null,
    inaccurate ? `inaccurate=${inaccurate}` : null,
    trainingMode ? `training_mode=${trainingMode}` : null,
    startDate ? `start_date=${startDate}` : null,
    endDate ? `end_date=${endDate}` : null,
  ]
    .filter(Boolean)
    .join('&');
  const response = await fetch(`/geojson/user_tracks?${params}`);
  const data = await response.json();

  return {
    data,
    config,
    source,
    labels: null,
    markers: null,
  };
};

export default load;
